let form = require('../form/form');

import Trackers from '../tracker/tracker';
import PreLoader from '../../modules/preloader';

jQuery(function($) {
    $(document).on('click', '.js-feedback-city', function(e) {
        e.preventDefault();

        const trackers = new Trackers();
        trackers.onCallBackFormShow();

        let region = $(this).attr('data-region');


        let contactsPrompt = {
            feedbackCity: {
                html: function() {
                    let ajax = new XMLHttpRequest();
                    let url = '/ajax/component/maximaster:feedback.form/city/?region=' + region;
                    ajax.open('GET', url, false);
                    ajax.send();
                    return JSON.parse(ajax.responseText).html;
                },
                submit: function(e, v, m) {
                    e.preventDefault();
                    let callbackForm = m.closest('form');
                    trackers.onCallBackButton();

                    let params = $.extend({}, form.formValidateDefaults, {
                        rules: {
                            feedback_name: { required: true },
                            feedback_city: { required: true },
                            feedback_phone: {
                                phoneMask: true
                            }
                        },
                        messages: {
                            feedback_name: {
                                required: $.validator.messages.feedback_name.required
                            },
                            feedback_city: {
                                required: $.validator.messages.feedback_city.required
                            },
                            feedback_phone: {
                                phoneMask: $.validator.messages.feedback_phone.phoneMask
                            }
                        },
                        submitHandler: function() {
                            const loader = new PreLoader();
                            loader.show();
                            $.ajax({
                                type: 'POST',
                                url: '/ajax/action/feedback_form/feedback/',
                                data: callbackForm.serialize(),
                                dataType: 'json',
                                success: function(response) {
                                    loader.hide();
                                    if (response.code == 200) {
                                        $('.jqiclose ').trigger('click');
                                        callbackForm.find('.form__input--correct').each(function(i, element) {
                                            $(element).removeClass('form__input--correct');
                                        });
                                        trackers.onPMfrmCallMeContact();

                                        $.prompt(contactsPrompt, {
                                            initialState: 'successFeedbackMessage'
                                        });
                                    } else {
                                        let errorDiv = $('<div/>', {
                                            class: 'form__error-msg',
                                            text: response.message
                                        });
                                        callbackForm.find('.form__head-label').after(errorDiv);
                                    }
                                }
                            });
                        }
                    });

                    callbackForm.validate(params);
                    callbackForm.valid();
                }
            },

            successCallbackMessage: {
                html: function() {
                    let ajax = new XMLHttpRequest();
                    ajax.open('GET', '/ajax/template/maximaster:callback.form/success/', false);
                    ajax.send();
                    return ajax.responseText;
                }
            },

            successFeedbackMessage: {
                html: function() {
                    /*  let ajax = new XMLHttpRequest();
                      ajax.open("GET", "/ajax/template/maximaster:feedback.form/success/", false);
                      ajax.send();
                      return ajax.responseText;*/
                    return (
                        '  <div class="prompt__content">\n' +
                        '       <p>Сообщение успешно отправлено.</p>\n' +
                        '    </div>'
                    );
                }
            }
        };

        $.prompt(contactsPrompt, { initialState: 'feedbackCity' });
    });
});



// WEBPACK FOOTER //
// ./blocks/feedback-city/feedback-city.js